'use strict';

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var PricingLevelFeature = _react2['default'].createClass({
    displayName: 'PricingLevelFeature',
    render: function render() {
        var classes = (0, _classnames2['default'])({
            'm-pricing-level--feature': true,
            'small-12': true,
            'columns': true,
            'block': true,
            'expanded': this.props.expanded
        });

        if (this.props.planName && this.props.planName.toLowerCase().indexOf('pro') === 0) {
            var numberClasses = (0, _classnames2['default'])({
                'number': true,
                'c-cerulean': this.props.name.toLowerCase().indexOf('documents per month') === 0
            });
        } else {
            var numberClasses = (0, _classnames2['default'])({
                'number': true,
                'c-cerulean': !this.props.isFree
            });
        }

        var nameClasses = (0, _classnames2['default'])({
            'name': true
        });

        var number = _react2['default'].createElement(
            'div',
            { className: numberClasses },
            this.props.number
        );
        var name = _react2['default'].createElement(
            'div',
            { className: nameClasses },
            this.props.name
        );
        var detail = _react2['default'].createElement(
            'div',
            { className: 'detail' },
            this.props.detail
        );
        return _react2['default'].createElement(
            'div',
            { className: classes },
            number,
            name,
            detail
        );
    }
});

module.exports = PricingLevelFeature;


/*****************
 ** WEBPACK FOOTER
 ** ./src/hellosign/components/pricing/pricing-level-feature.jsx
 ** module id = 1064
 ** module chunks = 0
 **/